module.exports = "/_next/static/images/SynthesizeImage-efa9aebdece00cbf66c10378e481b3d3.webp";